var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatusSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 10C0 4.48 4.47 0 9.99 0C15.52 0 20 4.48 20 10C20 15.52 15.52 20 9.99 20C4.47 20 0 15.52 0 10ZM2.00005 10C2.00005 14.42 5.58005 18 10.0001 18C14.4201 18 18.0001 14.42 18.0001 10C18.0001 5.58 14.4201 2 10.0001 2C5.58005 2 2.00005 5.58 2.00005 10Z",
    fill: "#12A963"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24267 13.6894C8.63319 14.0799 9.26636 14.0799 9.65688 13.6894L15.7252 7.62102C16.1158 7.23049 16.1158 6.59733 15.7252 6.2068C15.3347 5.81628 14.7015 5.81628 14.311 6.2068L8.95003 11.5678L6.12141 8.73918C5.73089 8.34865 5.09772 8.34865 4.7072 8.73918C4.31668 9.1297 4.31668 9.76287 4.7072 10.1534L8.22382 13.67C8.22999 13.6765 8.23628 13.683 8.24267 13.6894Z",
    fill: "#12A963"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStatusSuccess);
export default __webpack_public_path__ + "static/media/icon-status-success.3a229604d7a04c7ccb3c48b8bf2c7855.svg";
export { ForwardRef as ReactComponent };